const bankAccountRegex = /^(?:(\d*)-)?(\d+)\/(\d{4})$/;

function calculateIbanChecksum(iban: string): string {
  const ibanMoved = iban.slice(4) + iban.slice(0, 4);
  const ibanNumbered = ibanMoved
    .split('')
    .map((char) => {
      const code = char.charCodeAt(0);
      return code >= 65 && code <= 90 ? code - 55 : char;
    })
    .join('');
  // Calculate the modulo-97 remainder
  const ibanRemainder = BigInt(ibanNumbered) % BigInt(97);
  // Calculate the checksum
  const ibanChecksum = BigInt(98) - ibanRemainder;

  return ibanChecksum.toString().padStart(2, '0');
}

export function convertCzechAccountToIban(accountNumber: string): string {
  const bankAccountFull = accountNumber
      .replace(/ /g, '')
      .match(bankAccountRegex);
  if (bankAccountFull) {
    const bankAccountPrefix = bankAccountFull[1];
    const bankAccountNumber = bankAccountFull[2];
    const bankCode = bankAccountFull[3];
    const ibanPrefix = 'CZ00';
    const ibanBody =
        ibanPrefix +
        bankCode +
        (bankAccountPrefix || '').padStart(6, '0') +
        bankAccountNumber.padStart(10, '0');
    const ibanChecksum = calculateIbanChecksum(ibanBody);
    const ibanChecksumString = ibanChecksum.toString().padStart(2, '0');
    return (
        ibanPrefix.substring(0, 2) +
        ibanChecksumString +
        bankCode +
        (bankAccountPrefix || '').padStart(6, '0') +
        bankAccountNumber.padStart(10, '0')
    );
  }
  throw new Error('Invalid bank account number');
}

export function tryConvertCzechAccountToIban(accountNumber: string): string {
  const bankAccountFull = accountNumber
      .replace(/ /g, '')
      .match(bankAccountRegex);
  if (bankAccountFull) {
    const bankAccountPrefix = bankAccountFull[1];
    const bankAccountNumber = bankAccountFull[2];
    const bankCode = bankAccountFull[3];
    const ibanPrefix = 'CZ00';
    const ibanBody =
        ibanPrefix +
        bankCode +
        (bankAccountPrefix || '').padStart(6, '0') +
        bankAccountNumber.padStart(10, '0');
    const ibanChecksum = calculateIbanChecksum(ibanBody);
    const ibanChecksumString = ibanChecksum.toString().padStart(2, '0');
    return (
        ibanPrefix.substring(0, 2) +
        ibanChecksumString +
        bankCode +
        (bankAccountPrefix || '').padStart(6, '0') +
        bankAccountNumber.padStart(10, '0')
    );
  }

  return accountNumber;
}
